import React from 'react';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-material-ui';
import { Button } from '@material-ui/core';
import gql from 'graphql-tag';
import { WellFormStyles } from './WellTabPage';
import { useMutation, useQuery } from '@apollo/client';
import { EDIT_WELL } from '../../components/wells/WellQueries';
import LoadingView from '../../components/LoadingView';
import Typography from '@material-ui/core/Typography';
import Iframe from 'react-iframe';

const PlatQuery = gql`
  query GetWell($id: ID!) {
    Well(id: $id) {
      id
      apiNumber
      name
      platURL
    }
  }
`;

const PlatMap = ({ match, enqueueSnackbar }) => {
  const classes = WellFormStyles();

  const [updatePlat] = useMutation(EDIT_WELL);

  const { data, loading, error } = useQuery(PlatQuery, {
    variables: { id: match.params.wellID },
  });

  if (loading) {
    return <LoadingView />;
  }
  if (error) {
    return error.toString();
  }
  // Break well out of data returned from query
  const Well = data.Well[0] || [];

  return (
    <Formik
      onSubmit={(values, actions) => {
        actions.setSubmitting(true);
        return updatePlat({ variables: values })
          .then(() => {
            enqueueSnackbar('Successfully updated Plat URL', { variant: 'success' });
            actions.setSubmitting(false);
          })
          .catch((error) => {
            enqueueSnackbar(`Could not update Plat URL: ${error.toString()}`, { variant: 'error' });
            actions.setSubmitting(false);
          });
      }}
      initialValues={Well}
    >
      {(props) => {
        return (
          <Form id="updatePlat">
            <Field
              name='platURL'
              placeholder='Plat URL'
              component={TextField}
              label='Plat URL'
              className={classes.TextField}
              fullWidth
            />
            <div style={{ paddingTop: 20, width: 'auto' }}>
              <Iframe
                url={props.values.platURL}
                width='100%'
                height="100vh"
                position={"unset"}
                style={{ display: !props.values.platURL ? 'none' : 'block' }}
              />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default PlatMap;
